import React from 'react'
import {Control, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch} from 'react-hook-form'
import {IApplicationFormData} from '../../models/application-form'
import EmploymentDetailsSection from './sections/EmploymentDetailsSection'
import {createEmptyEmployment} from './sections/employmentDraft'
import WizardSectionCard from './sections/WizardSectionCard'

interface EmploymentStepProps {
  register: UseFormRegister<IApplicationFormData>
  control: Control<IApplicationFormData>
  errors?: FieldErrors<IApplicationFormData>
  setValue: UseFormSetValue<IApplicationFormData>
  watch: UseFormWatch<IApplicationFormData>
}

const EmploymentStep: React.FC<EmploymentStepProps> = ({
  register,
  control,
  errors,
  setValue,
  watch,
}) => {
  const employment = watch('employment')

  React.useEffect(() => {
    if (employment) {
      return
    }

    setValue('employment', createEmptyEmployment(), {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    })
  }, [employment, setValue])

  return (
    <>
      <div className='wizard-hint-card mb-4 d-flex' style={{padding: '20px'}}>
        <i className='bi bi-info-circle me-5 gradient-icon'></i>
        <span>Adding a reference from your employer can strengthen your Doora Card.</span>
      </div>
      <div>
        <div className='d-grid gap4'>
          <WizardSectionCard title='' className='p-5 mt-0'>
            <EmploymentDetailsSection
              register={register}
              control={control}
              errors={errors}
              watch={watch}
              setValue={setValue}
            />
          </WizardSectionCard>
        </div>
      </div>
    </>
  )
}

export default EmploymentStep
